import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { PrefixService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';
import { ApplicationContextService } from 'lib-core-shared';

@Component({
  selector: 'lib-text-box-with-dropdown',
  templateUrl: './text-box-with-dropdown.component.html',
  styleUrls: ['./text-box-with-dropdown.component.css']
})
export class TextBoxWithDropdownComponent extends ControlBaseDirective implements OnInit {
  public isEmbedded: boolean;
  @Input() dropdownType!: string;
  @Input() placeholder?: string;

  constructor(
    public roleService: RolePermissionService,
    private prefixService: PrefixService,
    public applicationContextService: ApplicationContextService
    ) { 
    super(roleService, applicationContextService);

    this.isEmbedded = this.applicationContextService.isApplicationEmbedded() ? true : false;
  }
  
  ngOnInit() {
    if (this.isEmbedded) {
      this.setBranchPrefix(this.applicationContextService.getBranchCodeFromUrl());
    } else {
      this.setBranchPrefix('ALL');
    }
    
    this.setProductPrefix('P');
  }

  selectedBranchPrefix!: string;

  setBranchPrefix(prefixCode: string) {
    this.selectedBranchPrefix = prefixCode;
    this.prefixService.changeBranchPrefix(prefixCode);
  }

  selectedProductPrefixLetter!: string;
  selectedProductPrefix = this.prefixService.selectedProductPrefixObs.subscribe((pref: any) => {
    this.selectedProductPrefixLetter = pref.replace('_', '');
  });

  setProductPrefix(prefixCode: string) {
    this.prefixService.changeProductPrefix(`${prefixCode}_`);
  }
}
